import useGlobalStore from '../stores/globalStore'

export function syncSelectedDelegateIdToStore(rawId) {
  const normalized = typeof rawId === 'string' && rawId.length > 0 ? rawId : null
  useGlobalStore.getState().setSelectedDelegateId(normalized)
  return normalized
}

export function persistSelectedDelegateIdToStorage(normalizedId) {
  if (normalizedId) {
    window.localStorage.setItem('selectedDelegateId', normalizedId)
  } else {
    window.localStorage.removeItem('selectedDelegateId')
  }
}
